/* Codex Curios — theme script. No dependencies. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Sigil forge. A faithful port of relic_forge.sigil() in the relic kit:
     the same campaign name always produces the same sigil, so the preview
     a customer sees is the mark that gets engraved.
     ------------------------------------------------------------------ */
  var enc = new TextEncoder();
  function seed(s) {
    return crypto.subtle.digest('SHA-256', enc.encode(String(s).trim().toLowerCase())).then(function (buf) {
      var hex = '';
      new Uint8Array(buf).forEach(function (b) { hex += b.toString(16).padStart(2, '0'); });
      return BigInt('0x' + hex);
    });
  }
  function f(x) { return x.toFixed(3); }
  function rad(d) { return d * Math.PI / 180; }
  function gcd(a, b) { return b ? gcd(b, a % b) : a; }

  async function sigil(name, opts) {
    opts = opts || {};
    var cx = 50, cy = 50, R = 46, stroke = opts.stroke || 1.1;
    var h = await seed(name);
    async function take(n) {
      var N = BigInt(n), v = h % N;
      h = h / N;
      if (h < 1000000n) h = await seed(name + v.toString() + String(n));
      return Number(v);
    }
    var table = { 7: [2, 3], 8: [3], 9: [2, 4], 10: [3], 11: [3, 4] };
    var n = [7, 8, 9, 10, 11][await take(5)];
    var step = table[n][await take(table[n].length)];
    await take(Math.floor(360 / n));
    var rot = -90, out = [], i, k;
    var s = 'fill="none" stroke="currentColor" stroke-width="' + stroke + '" stroke-linecap="round" stroke-linejoin="round"';
    var pts = [];
    for (i = 0; i < n; i++) pts.push([cx + R * .78 * Math.cos(rad(rot + 360 * i / n)), cy + R * .78 * Math.sin(rad(rot + 360 * i / n))]);
    out.push('<circle cx="50" cy="50" r="' + f(R) + '" ' + s + '/>', '<circle cx="50" cy="50" r="' + f(R * .92) + '" ' + s + '/>');
    var ticks = [n * 2, n * 3, n * 4][await take(3)];
    for (i = 0; i < ticks; i++) {
      var a = rad(rot + 360 * i / ticks);
      out.push('<line x1="' + f(cx + R * .92 * Math.cos(a)) + '" y1="' + f(cy + R * .92 * Math.sin(a)) + '" x2="' + f(cx + R * Math.cos(a)) + '" y2="' + f(cy + R * Math.sin(a)) + '" ' + s + '/>');
    }
    var g = gcd(n, step);
    for (var st = 0; st < g; st++) {
      var d = [], j = st;
      for (k = 0; k < n / g + 1; k++) { d.push((d.length ? 'L' : 'M') + f(pts[j][0]) + ',' + f(pts[j][1])); j = (j + step) % n; }
      out.push('<path class="sigil-draw" pathLength="1" d="' + d.join(' ') + '" ' + s + '/>');
    }
    var inner = [];
    for (k = 0; k < n; k++) inner.push(f(cx + R * .34 * Math.cos(rad(rot + 180 / n + 360 * k / n))) + ',' + f(cy + R * .34 * Math.sin(rad(rot + 180 / n + 360 * k / n))));
    out.push('<path d="M' + inner.join(' L') + ' Z" ' + s + '/>');
    var mask = (await take(Math.pow(2, n))) | 1;
    pts.forEach(function (p, idx) { if ((mask >> idx) & 1) out.push('<circle cx="' + f(p[0]) + '" cy="' + f(p[1]) + '" r="' + f(R * .055) + '" fill="#2a1c13" ' + s + '/>'); });
    var motif = Number((await seed(name + '|motif')) % 3n);
    var r0 = R * .16;
    if (motif === 0) {
      out.push('<path d="M' + f(cx - r0 * 1.6) + ',' + cy + ' Q' + cx + ',' + f(cy - r0 * 1.3) + ' ' + f(cx + r0 * 1.6) + ',' + cy + ' Q' + cx + ',' + f(cy + r0 * 1.3) + ' ' + f(cx - r0 * 1.6) + ',' + cy + ' Z" ' + s + '/>',
        '<circle cx="50" cy="50" r="' + f(r0 * .45) + '" fill="currentColor"/>');
    } else if (motif === 1) {
      out.push('<path d="M' + cx + ',' + f(cy - r0) + ' A' + f(r0) + ',' + f(r0) + ' 0 1 0 ' + cx + ',' + f(cy + r0) + ' A' + f(r0 * .75) + ',' + f(r0) + ' 0 1 1 ' + cx + ',' + f(cy - r0) + ' Z" fill="currentColor"/>');
    } else {
      var rr = r0 * 1.1, a1 = rad(-60), a2 = rad(-100);
      out.push('<path d="M' + f(cx + rr * Math.cos(a1)) + ',' + f(cy + rr * Math.sin(a1)) + ' A' + f(rr) + ',' + f(rr) + ' 0 1 1 ' + f(cx + rr * Math.cos(a2)) + ',' + f(cy + rr * Math.sin(a2)) + '" fill="none" stroke="currentColor" stroke-width="' + f(stroke * 2.2) + '" stroke-linecap="round"/>',
        '<circle cx="' + f(cx + rr * Math.cos(a1)) + '" cy="' + f(cy + rr * Math.sin(a1)) + '" r="' + f(Math.max(stroke * 1.4, R * .03)) + '" fill="currentColor"/>');
    }
    return out.join('');
  }
  window.CodexSigil = sigil;

  function paintSigil(svg, name) {
    if (!svg || !window.crypto || !crypto.subtle) return;
    var token = (svg._t = (svg._t || 0) + 1);
    sigil(name).then(function (markup) {
      if (token !== svg._t) return;
      var host = svg.closest('.plate') || svg.parentNode;
      host.classList.add('is-reforging');
      svg.innerHTML = markup;
      requestAnimationFrame(function () { requestAnimationFrame(function () { host.classList.remove('is-reforging'); }); });
    }).catch(function () {});
  }

  function initForges(root) {
    (root || document).querySelectorAll('[data-forge]').forEach(function (forge) {
      if (forge._init) return;
      forge._init = true;
      var nameIn = forge.querySelector('[data-forge-name]');
      var inscIn = forge.querySelector('[data-forge-insc]');
      var svg = forge.querySelector('[data-forge-sigil]');
      var nameOut = forge.querySelector('[data-forge-name-out]');
      var inscOut = forge.querySelector('[data-forge-insc-out]');
      var fallbackName = forge.getAttribute('data-forge-fallback') || 'Your Campaign';
      var timer;
      function renderName() {
        var v = nameIn && nameIn.value.trim() ? nameIn.value.trim() : fallbackName;
        if (nameOut) nameOut.textContent = v;
        paintSigil(svg, v);
      }
      function renderInsc() {
        if (!inscOut) return;
        var v = inscIn && inscIn.value.trim() ? inscIn.value.trim() : (inscOut.getAttribute('data-placeholder') || '');
        inscOut.textContent = v || ' ';
      }
      if (nameIn) nameIn.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(renderName, 160); });
      if (inscIn) inscIn.addEventListener('input', renderInsc);
      renderName();
      renderInsc();
    });
    (root || document).querySelectorAll('[data-sigil-static]').forEach(function (svg) {
      paintSigil(svg, svg.getAttribute('data-sigil-static'));
    });
  }

  /* ------------------------------------------------------------------
     Character counters
     ------------------------------------------------------------------ */
  function initCounters() {
    document.querySelectorAll('[data-count-for]').forEach(function (out) {
      var el = document.getElementById(out.getAttribute('data-count-for'));
      if (!el) return;
      var max = el.getAttribute('maxlength');
      function upd() { out.textContent = el.value.length + (max ? ' / ' + max : ''); }
      el.addEventListener('input', upd);
      upd();
    });
  }

  /* ------------------------------------------------------------------
     Product: gallery, variants, quantity, relic questionnaire
     ------------------------------------------------------------------ */
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function initProduct(section) {
    var dataEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('form[data-relic-form]');
    if (!form) return;
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var moneyFormat = section.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var submit = form.querySelector('[type="submit"]');
    var status = form.querySelector('[data-form-status]');

    // variant chips
    function currentOptions() {
      var opts = [];
      section.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[Number(group.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      return opts;
    }
    function onVariantChange() {
      if (!product) return;
      var opts = currentOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; }); });
      if (!variant) { submit.disabled = true; submit.querySelector('span').textContent = 'Unavailable'; return; }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
      if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, moneyFormat) : '';
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? submit.getAttribute('data-label') : 'Sold out';
      if (variant.featured_image) showImage(variant.featured_image.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    section.querySelectorAll('[data-option-index] input').forEach(function (i) { i.addEventListener('change', onVariantChange); });

    // gallery
    var mainImg = section.querySelector('[data-gallery-main]');
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    function showImage(id) {
      thumbs.forEach(function (t) {
        var on = String(t.getAttribute('data-image-id')) === String(id);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && mainImg) {
          mainImg.src = t.getAttribute('data-full');
          mainImg.srcset = t.getAttribute('data-srcset') || '';
          mainImg.alt = t.getAttribute('data-alt') || '';
        }
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.getAttribute('data-image-id')); }); });

    // quantity
    section.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-step')));
          input.value = v;
        });
      });
    });

    // validation with plain-language messages
    function fieldOf(el) { return el.closest('.field'); }
    function setError(el, msg) {
      var field = fieldOf(el);
      if (!field) return;
      var err = field.querySelector('.field__error');
      field.classList.toggle('is-invalid', !!msg);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (err) { err.textContent = msg || ''; err.hidden = !msg; }
    }
    function messageFor(el) {
      if (el.validity.valueMissing) return el.getAttribute('data-required-msg') || 'This one is needed to make your relic.';
      if (el.validity.tooLong) return 'Keep it under ' + el.maxLength + ' characters so it fits the engraving.';
      return el.validationMessage;
    }
    form.querySelectorAll('input, textarea, select').forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value) setError(el, el.checkValidity() ? '' : messageFor(el)); });
      el.addEventListener('input', function () { if (fieldOf(el) && fieldOf(el).classList.contains('is-invalid') && el.checkValidity()) setError(el, ''); });
    });
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var firstBad = null;
      form.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (el.type === 'hidden') return;
        var ok = el.checkValidity();
        setError(el, ok ? '' : messageFor(el));
        if (!ok && !firstBad) firstBad = el;
      });
      if (firstBad) {
        e.preventDefault();
        if (status) { status.classList.remove('is-ok'); status.textContent = 'A few details are missing. They are marked above.'; }
        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { firstBad.focus({ preventScroll: true }); }, 350);
        return;
      }
      if (status) { status.classList.add('is-ok'); status.textContent = 'Adding your relic to the satchel…'; }
      submit.disabled = true;
    });
  }

  /* ------------------------------------------------------------------
     Cart: quantity steppers submit the update form
     ------------------------------------------------------------------ */
  function initCart() {
    var form = document.querySelector('form[data-cart-form]');
    if (!form) return;
    form.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.getAttribute('data-step')));
          form.requestSubmit ? form.requestSubmit(form.querySelector('[name="update"]')) : form.submit();
        });
      });
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ------------------------------------------------------------------
     Menu drawer: close on link click or Escape
     ------------------------------------------------------------------ */
  function initDrawer() {
    document.querySelectorAll('.menu-drawer').forEach(function (d) {
      d.querySelectorAll('a, [data-close]').forEach(function (a) { a.addEventListener('click', function () { d.removeAttribute('open'); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') d.removeAttribute('open'); });
    });
  }

  function boot(root) {
    document.documentElement.classList.remove('no-js');
    initForges(root);
    initCounters();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCart();
    initDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Re-run inside the theme editor when a section is added or changed.
  document.addEventListener('shopify:section:load', function (e) {
    initForges(e.target);
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
    if (e.target.matches && e.target.matches('[data-product-section]')) initProduct(e.target);
  });
})();
